<template><div><h1>VUX V2.1.1Rc.9 released</h1>
<h2><a href="/en/components/alert.html">Alert</a></h2>
<ul><li>[fix] Fix onHide callback issue #1023 @jsonviewer</li>
</ul>
<h2><a href="/en/components/datetime-range.html">DatetimeRange</a></h2>
<ul><li>[feature] new component #970 @327326724</li>
</ul>
<h2><a href="/en/components/popup.html">Popup</a></h2>
<ul><li>[enhance] Better mask transition</li>
<li>[feature] Support tranparent background</li>
<li>[feature] Support less variable: @popup-background-color</li>
</ul>
<h2><a href="/en/components/swipeout.html">Swipeout</a></h2>
<ul><li>[fix] Fix left-menu is shown when swiping right quickly</li>
</ul>
<h2><a href="/en/components/toast.html">Toast</a></h2>
<ul><li>[enhance] Reset props every time plugin.show is called #870 @jsonviewer</li>
</ul>
<h2><a href="/en/components/date.html">Date</a></h2>
<ul><li>[feature] Add dateRange tool function</li>
<li>[feature] format support string-type of date</li>
</ul>
<h2><a href="/en/components/number.html">Number</a></h2>
<ul><li>[feature] Add numberRange tool function</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.9 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.9-89.vue?458e49de